import { Command } from 'commander';
import { GenerateConnectionCommand } from './generateConnectionCommand';

export function ConnectionCommand(): Command {
  const cmd = new Command('connection');
  cmd.alias('co').description('Connection related commands.');

  cmd.addCommand(GenerateConnectionCommand());
  return cmd;
}
